import HttpReq from "../../service/httpReq"
import { PathFactory } from "./utils"
import ReportsRepo from "./repoertsRepo"
class ImportsRepo {

    static mnmgtPath = 'api/mgmt/table/imports'

    static list(successConsumer, errorConsumer) {
        HttpReq.get(ImportsRepo.mnmgtPath, successConsumer, errorConsumer)
    }

    static get(id, successConsumer, errorConsumer) {
        HttpReq.get(
            PathFactory.create([ImportsRepo.mnmgtPath, id]),
            successConsumer, errorConsumer)
    }

    static getActiveBySchema(schemaId, successConsumer, errorConsumer) {
        HttpReq.get(
            PathFactory.create([ImportsRepo.mnmgtPath], new URLSearchParams({ schemaId })),
            successConsumer, errorConsumer)
    }

    static create(spec, successConsumer, errorConsumer) {
        HttpReq.post(
            PathFactory.create([ImportsRepo.mnmgtPath]),
            spec, successConsumer, errorConsumer)
    }

    static applyImport(id, successConsumer, errorConsumer) {
        HttpReq.post(
            PathFactory.create([ImportsRepo.mnmgtPath, id], new URLSearchParams({ action: "apply" })),
            {}, (response) => { ReportsRepo.invalidateCache(); successConsumer(response); }, errorConsumer)
    }

    static checkImpact(id, successConsumer, errorConsumer) {
        HttpReq.post(
            PathFactory.create([ImportsRepo.mnmgtPath, id], new URLSearchParams({ action: "checkImpact" })),
            {}, successConsumer, errorConsumer)
    }


    static getReport(successConsumer, errorConsumer) {
        HttpReq.get(
            PathFactory.create([ImportsRepo.mnmgtPath, "report"]),
            successConsumer, errorConsumer)
    }

    static getDiff(id, successConsumer, errorConsumer) {
        HttpReq.get(
            PathFactory.create([ImportsRepo.mnmgtPath, id, "diff"]),
            successConsumer, errorConsumer)
    }

    static refreshDiffsSummary(successConsumer, errorConsumer) {
        HttpReq.put(
            PathFactory.create([ImportsRepo.mnmgtPath, "diff"]), {},
            successConsumer, errorConsumer)
    }

    static fullRefresh(id, successConsumer, errorConsumer) {
        HttpReq.put(
            PathFactory.create([ImportsRepo.mnmgtPath, id], new URLSearchParams({ action: "refresh" })),
            successConsumer, errorConsumer)
    }

    static automaticAnnotationRefresh(id, successConsumer, errorConsumer) {
        HttpReq.put(PathFactory.create([ImportsRepo.mnmgtPath, id, "metadata", "automatic"]), {}, successConsumer, errorConsumer)
    }

    static automaticMappingRefresh(id, successConsumer, errorConsumer) {
        HttpReq.put(PathFactory.create([ImportsRepo.mnmgtPath, id, "mappings", "automatic"]), {}, successConsumer, errorConsumer)
    }

    static automaticAnnotationsRefresh(successConsumer, errorConsumer) {
        HttpReq.put(PathFactory.create([ImportsRepo.mnmgtPath, "metadata", "automatic"]), {}, successConsumer, errorConsumer)
    }

    static automaticMappingsRefresh(successConsumer, errorConsumer) {
        HttpReq.put(PathFactory.create([ImportsRepo.mnmgtPath, "mappings", "automatic"]), {}, successConsumer, errorConsumer)
    }

    static reconfigureManualAnnotations(id, spec, successConsumer, errorConsumer) {
        HttpReq.put(
            PathFactory.create([ImportsRepo.mnmgtPath, id, "annotations", "manual"]), spec, successConsumer, errorConsumer)
    }


    static extract(createSpec, successConsumer, errorConsumer) {
        HttpReq.put(ImportsRepo.mnmgtPath, createSpec, successConsumer, errorConsumer)
    }

    // static update(updateReportSpec, reportConsumer, errorConsumer) {
    //     Cache.clear()
    //     HttpReq.put(ReportsRepo.mgmtPath, updateReportSpec, reportConsumer, errorConsumer)
    // }

    static delete(id, resConsumer, errorConsumer) {
        HttpReq.delete(PathFactory.create([ImportsRepo.mnmgtPath, id]), resConsumer, errorConsumer)
    }

    static metadataUpdate(importId, data, successConsumer, errorConsumer) {
        HttpReq.put(PathFactory.create([ImportsRepo.mnmgtPath, importId, "metadata"]), data, successConsumer, errorConsumer)
    }

    static mappingsUpdate(importId, data, successConsumer, errorConsumer) {
        HttpReq.put(PathFactory.create([ImportsRepo.mnmgtPath, importId, "mapping"]), data, successConsumer, errorConsumer)
    }

    static reportUpdate(importId, data, successConsumer, errorConsumer) {
        HttpReq.put(PathFactory.create([ImportsRepo.mnmgtPath, importId, "table", "reports"]), data, successConsumer, errorConsumer)
    }

    static descriptorsUpdate(importId, data, successConsumer, errorConsumer) {
        HttpReq.put(PathFactory.create([ImportsRepo.mnmgtPath, importId, "table", "descriptors"]), data, successConsumer, errorConsumer)
    }

    static reportsBatchUpdate(importId, data, successConsumer, errorConsumer) {
        HttpReq.put(PathFactory.create([ImportsRepo.mnmgtPath, importId, "table", 'reports?method=batch']), data, successConsumer, errorConsumer)
    }

    static recalculateTableAPICall(importId, data, successConsumer, errorConsumer) {
        // HttpReq.post(PathFactory.create([ImportsRepo.mnmgtPath, importId, "recalculateTableAPICall"]), data, successConsumer, errorConsumer)
        console.log("recalculation api call here")
        console.log("success consumer is triggered below")
        successConsumer()
    }

}

export default ImportsRepo